import ButtonAction from "../../../../../components/buttons/ButtonAction";
import HeadTittle from "../../../../../components/HeadTittle";
import NotInformation from "../../../../../components/NotInformation";
import { BasketResumeApp } from "../../Functionality/BasketResumeApp";
import DishResume from "./DishResume";
import OrderDetailsCard from "./OrderDetailsCard";
import DivContainerBody from "../../../../../components/DivContainerBody";
import BannerInfo from './BannerInfo';
import React from 'react';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const BasketResume = () => {
    const {
        t,
        isItems,
        filteredMeals,
        costTotal,
        foodieSetting,
        showBanner,
        setShowBanner,
        handleSaveOrder,
        handleOnBack,
        handleSelection
    } = BasketResumeApp();

    return (
        <>
            <HeadTittle name="order" onBack={handleOnBack}>
                <ButtonAction
                    id="btn_br_confirm"
                    name="confirm_order"
                    splitName={false}
                    className="btn-icon-primary-800"
                    onClick={() => handleSaveOrder()}
                    disabled={!isItems}
                />
            </HeadTittle>

            <DivContainerBody>
                { showBanner && isItems > 0 &&
                    <BannerInfo
                        t={t}
                        className="col-12 mb-4"
                        foodieSetting={foodieSetting}
                        setShowBanner={setShowBanner}
                    />
                }

                <div className={"col-12 mb-5"}>
                    {!isItems ?
                        <div className="background-shades-100 h-75 w-100">
                            <NotInformation text={t('no_meal_has_been_selected_yet')} />
                        </div>
                        :
                        <OrderDetailsCard costTotal={costTotal}>
                            {filteredMeals?.map(dish => (
                                <DishResume
                                    key={dish.id}
                                    info={dish?.meals[0]}
                                    handleSelection={handleSelection}
                                    foodieSetting={foodieSetting}
                                />
                            ))}
                        </OrderDetailsCard>
                    }
                </div>

            </DivContainerBody>

        </>
    );
};

export default BasketResume;
